<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-body">
                <form>
                    <div class="form-row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                            <label for="dateFrom">{{ 'pages.generic.dateFromTo' | translate }}</label>
                            <div class="row">
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                    <input type="date" class="form-control" [min]=minDate [max]=maxDate name="dateFrom" aria-describedby="dateFrom"
                                        [(ngModel)]="dateFrom" #dateFromF="ngModel">

                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                    <input type="date" class="form-control" [min]=minDate [max]=maxDate name="dateTo" aria-describedby="dateTo"
                                        [(ngModel)]="dateTo" #dateToF="ngModel">
                                </div>
                              <div class="col-xl-8 col-lg-6 col-md-12 col-sm-12 col-12 p-1 text-danger" *ngIf="(dateFromF.dirty || dateFromF.touched || dateToF.dirty || dateToF.touched) &&!validateDates()">
                                Please enter valid from and to values and ensure that the from date is before the to date..
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                        <label for="type">{{ 'pages.support.dashboard.fieldTitles.type' | translate }}</label>
                        <select class="form-control" name="type" aria-describedby="type" [(ngModel)]="currentSlaType">
                            <option></option>
                            <option value="firstresponse">First Response SLA</option>
                            <option value="customersla">Resolution SLA</option>
                        </select>
                    </div>
                    <button class="btn btn-primary" [disabled]="!validateDates() || !currentSlaType" (click)="generate();">{{ 'pages.generic.generate' | translate}} </button>
                </form>

            </div>
        </div>

    </div>
</div>


<div class="row mt-5 justify-content-center p-5" *ngIf="!cases && loading">
    <div class="spinner-border text-primary" role="status">
        <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
    </div>
</div>

<div class="row mt-5" *ngIf="cases && !loading">
    <div class="col-12">

            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">

                    <highcharts-chart
                        [Highcharts]="Highcharts"
                        [options]="catPieChartOptions"
                        style="width: 100%; height: 400px; display: block;"
                    ></highcharts-chart>

                </div>
            </div>

            <div class="row pt-5">
                <div class="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-4">
                    <div class="card boxshadow">
                        <div class="card-body h-90">
                            <div class="text-center">
                                <div class="m-r-0 align-self-center"><span class="lstick"></span></div>
                                <div class="align-self-center max-width">
                                    <h6 class="text-muted m-t-10 m-b-0 m-h-2">Total cases<br/><br/></h6>
                                    <h3 class="orangeText"> {{cases.length}}<br/><br/></h3>
                                    <i class="fa fa-spinner fa-spin fa-2x p-2" *ngIf="!cases"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-4">
                    <div class="card boxshadow">
                        <div class="card-body h-90">
                            <div class="text-center">
                                <div class="m-r-0 align-self-center"><span class="lstick"></span></div>
                                <div class="align-self-center max-width">
                                    <h6 class="text-muted m-t-10 m-b-0 m-h-2">Milestone<br/>SLA met</h6>
                                    <h3 class="m-t-0" *ngIf="slaCustomerMet > 0"> {{((slaCustomerMet/slaCustomerTotal)*100) | number : '1.2-2'}}%<br/><br/></h3>
                                    <h3 class="m-t-0" *ngIf="slaCustomerMet == 0">NO<br/>CASES</h3>
                                    <i class="fa fa-spinner fa-spin fa-2x p-2" *ngIf="!cases"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-4">
                    <div class="card boxshadow">
                        <div class="card-body h-90">
                            <div class="text-center">
                                <div class="m-r-0 align-self-center"><span class="lstick"></span></div>
                                <div class="align-self-center max-width">
                                    <h6 class="text-muted m-t-10 m-b-0 m-h-2">Critical priority<br/>SLA Met</h6>
                                    <h3 class="m-t-0" *ngIf="sev1TotalFirstResponse > 0">{{((sev1MetFirstResponse/sev1TotalFirstResponse)*100) | number : '1.2-2'}}%<br/><br/></h3>
                                    <h3 class="m-t-0" *ngIf="sev1TotalFirstResponse == 0">NO<br/>CASES</h3>
                                    <i class="fa fa-spinner fa-spin fa-2x p-2" *ngIf="!cases"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-4">
                    <div class="card boxshadow">
                        <div class="card-body">
                            <div class="text-center">
                                <div class="m-r-0 align-self-center"><span class="lstick"></span></div>
                                <div class="align-self-center max-width">
                                    <h6 class="text-muted m-t-10 m-b-0 m-h-2">High priority<br/>SLA Met</h6>
                                    <h3 class="m-t-0" *ngIf="sev2TotalFirstResponse > 0">{{((sev2MetFirstResponse/sev2TotalFirstResponse)*100) | number : '1.2-2'}}%<br/><br/></h3>
                                    <h3 class="m-t-0" *ngIf="sev2TotalFirstResponse == 0">NO<br/>CASES</h3>
                                    <i class="fa fa-spinner fa-spin fa-2x p-2" *ngIf="!cases"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-4">
                    <div class="card boxshadow">
                        <div class="card-body">
                            <div class="text-center">
                                <div class="m-r-0 align-self-center"><span class="lstick"></span></div>
                                <div class="align-self-center max-width">
                                    <h6 class="text-muted m-t-10 m-b-0 m-h-2">Medium priority<br/>SLA met </h6>
                                    <h3 class="m-t-0" *ngIf="sev3TotalFirstResponse > 0">{{((sev3MetFirstResponse/sev3TotalFirstResponse)*100) | number : '1.2-2'}}%<br/><br/></h3>
                                    <h3 class="m-t-0" *ngIf="sev3TotalFirstResponse == 0">NO<br/>CASES</h3>
                                    <i class="fa fa-spinner fa-spin fa-2x p-2" *ngIf="!cases"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-4">
                    <div class="card boxshadow">
                        <div class="card-body m-h-7">
                            <div class="text-center">
                                <div class="m-r-0 align-self-center"><span class="lstick"></span></div>
                                <div class="align-self-center max-width">
                                    <h6 class="text-muted m-t-10 m-b-0 m-h-2">Low priority<br/>SLA met </h6>
                                    <h3 class="m-t-0" *ngIf="sev4TotalFirstResponse > 0">{{((sev4MetFirstResponse/sev4TotalFirstResponse)*100) | number : '1.2-2'}}%<br/><br/></h3>
                                    <h3 class="m-t-0" *ngIf="sev4TotalFirstResponse == 0">NO<br/>CASES</h3>
                                    <i class="fa fa-spinner fa-spin fa-2x p-2" *ngIf="!cases"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

    </div>
</div>


<div *ngIf="cases && !loading" style="margin-top: 2rem;">

        <ngb-accordion #acc="ngbAccordion">
            <ngb-panel>
                <ng-template ngbPanelTitle>
                    <i class="fa fa-wrench themeColor"></i> <span class="themeColor"> Change Requests</span>
                </ng-template>
                <ng-template ngbPanelContent>

                    <div *ngIf="changes && changes.length > 0">
                        <div class="p-0">

                            <div class="row faketableheaderrow m-0 p-2" style="font-weight: bold;">
                                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 faketableheader">{{ 'pages.support.dashboard.fieldTitles.reference' | translate }}</div>
                                <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 d-none d-sm-block faketableheader">{{ 'pages.support.dashboard.fieldTitles.subject' | translate }}</div>
                                <div class="col-xl-2 col-lg-2 col-md-4 d-none d-md-block faketableheader">{{ 'pages.support.dashboard.fieldTitles.priority' | translate }}</div>
                                <div class="col-xl-2 col-lg-2 d-none d-lg-block faketableheader">{{ 'pages.support.dashboard.fieldTitles.created' | translate }}</div>
                                <div class="col-xl-2 d-none d-xl-block faketableheader">{{ 'pages.reports.slaType' | translate }}</div>
                                <div class="col-xl-1 col-lg-2 d-none d-lg-block faketableheader">{{ 'pages.reports.slaMet' | translate }}</div>
                            </div>

                            <div class="row faketablecellrow m-0 p-2 click" *ngFor="let case of changes"
                                [routerLink]="['/support/view/' + case.CaseId]" routerLinkActive="activeLink">
                                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 faketablecell" >{{case.Case.CaseNumber}}</div>
                                <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 d-none d-sm-block faketablecell">{{case.Case.Subject}}</div>
                                <div class="col-xl-2 col-lg-2 col-md-4 d-none d-md-block faketablecell">{{case.Case.Priority}}</div>                                
                                <div class="col-xl-2 col-lg-2 d-none d-lg-block faketablecell">{{case.Case.CreatedDate | date: 'dd/MM/yyyy HH:mm'}}</div>
                                <div class="col-xl-2 d-none d-xl-block faketablecell">{{case.MilestoneType.Name}}</div>
                                <div class="col-xl-1 col-lg-2 d-none d-lg-block faketablecell">{{case.IsViolated ? 'No' : 'Yes'}}</div>
                            </div>

                        </div>
                    </div>

                    <div *ngIf="!changes || changes.length == 0">
                        <div class="p-0">
                            <h4>No Changes found for this reporting period</h4>
                        </div>
                    </div>

                </ng-template>
            </ngb-panel>

            <ngb-panel>
                <ng-template ngbPanelTitle>
                    <i class="fa fa-warning themeColor"></i><span class="themeColor"> Incidents</span>
                </ng-template>
                <ng-template ngbPanelContent>

                    <div *ngIf="incidents && incidents.length > 0">
                        <div class="p-0">

                            <div class="row m-0 p-2" style="font-weight: bold;">
                                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 faketableheader">{{ 'pages.support.dashboard.fieldTitles.reference' | translate }}</div>
                                <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 d-none d-sm-block faketableheader">{{ 'pages.support.dashboard.fieldTitles.subject' | translate }}</div>
                                <div class="col-xl-2 col-lg-2 col-md-4 d-none d-md-block faketableheader">{{ 'pages.support.dashboard.fieldTitles.priority' | translate }}</div>
                                <div class="col-xl-2 col-lg-2 d-none d-lg-block faketableheader">{{ 'pages.support.dashboard.fieldTitles.created' | translate }}</div>
                                <div class="col-xl-2 d-none d-xl-block faketableheader">{{ 'pages.reports.slaType' | translate }}</div>
                                <div class="col-xl-1 col-lg-2 d-none d-lg-block faketableheader">{{ 'pages.reports.slaMet' | translate }}</div>
                            </div>

                            <div class="row m-0 p-2 click" *ngFor="let case of incidents"
                                [routerLink]="['/support/view/' + case.CaseId]" routerLinkActive="activeLink">
                                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 faketablecell" >{{case.Case.CaseNumber}}</div>
                                <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 d-none d-sm-block faketablecell">{{case.Case.Subject}}</div>
                                <div class="col-xl-2 col-lg-2 col-md-4 d-none d-md-block faketablecell">{{case.Case.Priority}}</div>                                
                                <div class="col-xl-2 col-lg-2 d-none d-lg-block faketablecell">{{case.Case.CreatedDate | date: 'dd/MM/yyyy HH:mm'}}</div>
                                <div class="col-xl-2 d-none d-xl-block faketablecell">{{case.MilestoneType.Name}}</div>
                                <div class="col-xl-1 col-lg-2 d-none d-lg-block faketablecell">{{case.IsViolated ? 'No' : 'Yes'}}</div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="!incidents || incidents.length == 0">
                        <div class="p-0">
                            <h4>No Incidents found for this reporting period</h4>
                        </div>
                    </div>

                </ng-template>
            </ngb-panel>

            <ngb-panel>
                <ng-template ngbPanelTitle>
                    <i class="fa fa-ticket themeColor"></i> <span class="themeColor"> Service requests</span>
                </ng-template>
                <ng-template ngbPanelContent>

                    <div *ngIf="serviceReqs && serviceReqs.length > 0">
                        <div class="p-0">

                            <div class="row m-0 p-2" style="font-weight: bold;">
                                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 faketableheader">{{ 'pages.support.dashboard.fieldTitles.reference' | translate }}</div>
                                <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 d-none d-sm-block faketableheader">{{ 'pages.support.dashboard.fieldTitles.subject' | translate }}</div>
                                <div class="col-xl-2 col-lg-2 col-md-4 d-none d-md-block faketableheader">{{ 'pages.support.dashboard.fieldTitles.priority' | translate }}</div>
                                <div class="col-xl-2 col-lg-2 d-none d-lg-block faketableheader">{{ 'pages.support.dashboard.fieldTitles.created' | translate }}</div>
                                <div class="col-xl-2 d-none d-xl-block faketableheader">{{ 'pages.reports.slaType' | translate }}</div>
                                <div class="col-xl-1 col-lg-2 d-none d-lg-block faketableheader">{{ 'pages.reports.slaMet' | translate }}</div>
                            </div>

                            <div class="row m-0 p-2 click" *ngFor="let case of serviceReqs"
                                 [routerLink]="['/support/view/' + case.CaseId]" routerLinkActive="activeLink">
                                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 faketablecell" >{{case.Case.CaseNumber}}</div>
                                <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 d-none d-sm-block faketablecell">{{case.Case.Subject}}</div>
                                <div class="col-xl-2 col-lg-2 col-md-4 d-none d-md-block faketablecell">{{case.Case.Priority}}</div>                                
                                <div class="col-xl-2 col-lg-2 d-none d-lg-block faketablecell">{{case.Case.CreatedDate | date: 'dd/MM/yyyy HH:mm'}}</div>
                                <div class="col-xl-2 d-none d-xl-block faketablecell">{{case.MilestoneType.Name}}</div>
                                <div class="col-xl-1 col-lg-2 d-none d-lg-block faketablecell">{{case.IsViolated ? 'No' : 'Yes'}}</div>
                            </div>

                        </div>
                    </div>

                    <div *ngIf="!serviceReqs || serviceReqs.length == 0">
                        <div class="p-0">
                            <h4>No Service Requests found for this reporting period</h4>
                        </div>
                    </div>

                </ng-template>
            </ngb-panel>
        </ngb-accordion>

    <div class="row">
        <div class="col text-right mt-3">
            <button class="btn btn-primary" (click)="generatePDF();" *ngIf="!loadingPDF">{{ 'pages.generic.downloadPDF' | translate}}</button>

            <div class="spinner-border text-primary" *ngIf="loadingPDF">
                <span class="sr-only">{{ 'pages.generic.loadingPDF' | translate }}</span>
            </div>
        </div>
    </div>


</div>
